export  { IHeaderGeneralOptions, HorizontalHeaderSlot, VerticalHeaderSlot }  from "./header.props";
export const name = "HeaderComponent";
